export class CanaisComunicacaoWhatsAppChatTexto {
  public message: string;

  constructor() { }
}
